// Photo Albums Data
// Each album contains: title, googlePhotosLink, thumbnail image, and description

export const photoAlbums = [
  {
    id: "dad-growing-up",
    title: "Dad Growing Up",
    description: "Photos of Dad throughout his childhood and youth",
    googlePhotosLink: "https://photos.app.goo.gl/yUanWCPFay4aYiZDA",
    thumbnail: "/images/googlePhotos/dad.jpg",
    category: "family",
  },
  {
    id: "dad-memorial",
    title: "Paul Dymock Memorial Photos",
    description: "Pictures used for Dad's memorial service",
    googlePhotosLink: "https://photos.app.goo.gl/Akr6i7HM8D5cycd1A", // Replace with actual link
    thumbnail: "/images/googlePhotos/dad-missionary.jpg",
    category: "family",
  },
  {
    id: "funeral",
    title: "Paul Dymock Funeral",
    description: "Photos from Dad's funeral service",
    googlePhotosLink: "https://photos.app.goo.gl/qyhfHJ1whW6WomYZ7",
    thumbnail: "/images/googlePhotos/funeral-program.jpg",
    category: "family",
  },
  {
    id: "annual-family",
    title: "Annual Family Pictures",
    description: "Our yearly family photos",
    googlePhotosLink: "https://photos.app.goo.gl/VmuV1pKs2md25P3x1",
    thumbnail: "/images/googlePhotos/family-pictures.jpg",
  },
  {
    id: "pre-marriage",
    title: "Pre-Marriage Era",
    description: "Photos from before Mom and Dad were married",
    googlePhotosLink: "https://photos.app.goo.gl/munoAmiVGtqnX5iE7",
    thumbnail: "/images/googlePhotos/pre-marriage.jpg",
    category: "family",
  },
  // ryan era https://photos.app.goo.gl/vTMfXxfnWhiRsXkNA
  {
    id: "ryan-era",
    title: "Ryan Era",
    description: "Photos from when Ryan was born until Kellianne was born",
    googlePhotosLink: "https://photos.app.goo.gl/vTMfXxfnWhiRsXkNA",
    thumbnail: "/images/googlePhotos/ryan-era.jpg",
  },
  //kellianne era https://photos.app.goo.gl/sYeAZeGHwH8sHi5V7
  {
    id: "kellianne-era",
    title: "Kellianne Era",
    description: "Photos from when Kellianne was born until Heidi was born",
    googlePhotosLink: "https://photos.app.goo.gl/sYeAZeGHwH8sHi5V7",
    thumbnail: "/images/googlePhotos/kellianne-era.jpg",
    category: "family",
  },
  // heidi era https://photos.app.goo.gl/tPEmcW2fLDdN7WxR8
  {
    id: "heidi-era",
    title: "Heidi Era",
    description: "Photos from when Heidi was born until Amy was born",
    googlePhotosLink: "https://photos.app.goo.gl/tPEmcW2fLDdN7WxR8",
    thumbnail: "/images/googlePhotos/heidi-era.jpg",
    category: "family",
  },
  // Amy Era https://photos.app.goo.gl/B3NcJf3aGg5sTwvM8
  {
    id: "amy-era",
    title: "Amy Era",
    description: "Photos from when Amy was born until Matthew was born",
    googlePhotosLink: "https://photos.app.goo.gl/B3NcJf3aGg5sTwvM8",
    thumbnail: "/images/googlePhotos/amy-era.jpg",
    category: "family",
  },
  // Birthdays https://photos.app.goo.gl/opoJw7gVxj12zYGX8
  {
    id: "birthdays",
    title: "Birthdays",
    description: "Birthday celebrations over the years",
    googlePhotosLink: "https://photos.app.goo.gl/opoJw7gVxj12zYGX8",
    thumbnail: "/images/googlePhotos/birthdays.jpg",
    category: "family",
  },
  // Halloween https://photos.app.goo.gl/Ycy6ExqZ2YLmrgGG8
  {
    id: "halloween",
    title: "Halloween",
    description: "Halloween costumes and celebrations",
    googlePhotosLink: "https://photos.app.goo.gl/Ycy6ExqZ2YLmrgGG8",
    thumbnail: "/images/googlePhotos/halloween.jpg",
    category: "family",
  },
  //Christmas https://photos.app.goo.gl/6iQqKzXjYZcKxtsU8
  {
    id: "christmas",
    title: "Christmas",
    description: "Christmas season events and memories",
    googlePhotosLink: "https://photos.app.goo.gl/6iQqKzXjYZcKxtsU8",
    thumbnail: "/images/googlePhotos/christmas.png",
    category: "family",
  },
]

// Helper function to get albums by category
export const getAlbumsByCategory = (category) => {
  if (!category) return photoAlbums
  return photoAlbums.filter((album) => album.category === category)
}

// Helper function to get album by id
export const getAlbumById = (id) => {
  return photoAlbums.find((album) => album.id === id)
}
